import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../service/global.service';
import {AuthService} from '../services/accounts/auth.service';
import {RbacService} from '../services/accounts/rbac.service';
import {ThemeService} from '../services/theme.service';
import {buildMenuList} from './menu-builder';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  companyName: string = '';
  hasDepartments = false;

  // let peopleMenu =  {'title':'People','url':'/people','icon':'person.png','menu_opened':false,'openedImage':'people_select.png','showSubmenu':false}
  showCustomerCareInfo = false;
  menuList: any = buildMenuList(null);

  bottomMenuList: any = [
    {title: 'Help', url: '', icon: 'help.png'},
    //{'title': 'Logout', 'url': '/sign-in', 'icon': 'exit.png'},
    // {'title': 'Dark', 'url': '/button3', 'icon': 'sun.png'},
    // {'title': 'Light', 'url': '/button4', 'icon': 'half  moon.png'},
  ];

  constructor(
    public global: GlobalService,
    public auth: AuthService,
    private rbac: RbacService,
    private router: Router,
    private route: ActivatedRoute,
    public themeService: ThemeService
  ) {
    this.companyName = this.auth.user().company_name;
  }

  ngOnInit() {
    this.global.hasDepartments$.subscribe(value => {
      this.hasDepartments = value;
    });

    this.rbac.rbac$.subscribe(me => {
      this.menuList = buildMenuList(me);
      this.highlightActiveMenu(this.router.url);
    });

    // Highlight active route after navigation ends
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const currentUrl = event.urlAfterRedirects;
        this.highlightActiveMenu(currentUrl);
      });
  }

  highlightActiveMenu(currentUrl: string) {
    const normalizedUrl = this.normalizeUrl(currentUrl);
    this.menuList.forEach((item: { menu_opened: boolean; showSubmenu: boolean; url: string; submenu: any[]; }) => {
      item.menu_opened = false;
      item.showSubmenu = false;

      if (item.url && this.isActiveRoute(normalizedUrl, item.url)) {
        item.menu_opened = true;
      }

      if (item.submenu && item.submenu.length > 0) {
        item.submenu.forEach(sub => {
          sub.menu_opened = false;
          if (this.isActiveRoute(normalizedUrl, sub.url)) {
            sub.menu_opened = true;
            item.menu_opened = true;
            item.showSubmenu = true;
          }
        });
      }
    });
  }

  normalizeUrl(url: string): string {
    const path = (url || '').split('?')[0].split('#')[0];
    return path === '/' ? '/home' : path;
  }

  isActiveRoute(currentUrl: string, itemUrl: string): boolean {
    if (!itemUrl) {
      return false;
    }

    return currentUrl === itemUrl;
  }


  onMenuItemClick(item: any) {
    // Check if the clicked item is the "Logout" item
    if (item.title === 'Logout') {
      localStorage.removeItem('userdata');
      this.global.redirect('sign-in');
    }
  }

  showCustomerCare() {
    this.showCustomerCareInfo = !this.showCustomerCareInfo
  }

  toggleSubmenu1(menuItem: any): void {
    const hasSubmenu = !!(menuItem.submenu && menuItem.submenu.length);
    const shouldOpen = hasSubmenu ? !menuItem.showSubmenu : true;

    this.menuList.forEach((otherItem: any) => {
      if (otherItem !== menuItem) {
        otherItem.menu_opened = false;
        otherItem.showSubmenu = false;
      }
    });

    menuItem.showSubmenu = hasSubmenu && shouldOpen;
    menuItem.menu_opened = shouldOpen;
  }

  toggleSubMenu(item: any) {
    if (item.disabled) {
      return;
    }
    item.menu_opened = true;

    this.menuList.forEach((otherItem: any) => {
      // otherItem.menu_opened = false;
      if (otherItem.submenu && otherItem.submenu.length > 0) {
        otherItem.submenu.forEach((submenuItem: any) => {
          if (submenuItem.title != item.title) {
            submenuItem.menu_opened = false;
          }
        });
      }
    });
  }

  toggleMenu(item: any): void {
    if (item.disabled) {
      return;
    }
    this.toggleSubmenu1(item);
    if (item.url) {
      this.router.navigate([item.url]);
    }
  }

  isCustomBackground: boolean = false;

  // Function to toggle background color
  toggleBackgroundColor(): void {
    this.isCustomBackground = !this.isCustomBackground;
  }
}
